var exports = {
  "Hp": "annotationsHeaderFileName__SqhtUK",
  "qV": "skeleton__RoHBzc",
  "wx": "header__CHzlGd",
  "s$": "filePath__qlmWgj",
  "ip": "diffPreview__eIwxG5",
  "mc": "diffLine__z5NMIP",
  "aY": "lineNumberCol__LFplSu",
  "t5": "diffContent__IQp52A",
};

module.exports = exports;
